export enum TelemetrySemanticType {
  Acceleration = "Acceleration",
  Angle = "Angle",
  AngularAcceleration = "AngularAcceleration",
  AngularVelocity = "AngularVelocity",
  ApparentPower = "ApparentPower",
  Area = "Area",
  Capacitance = "Capacitance",
  Current = "Current",
  DataRate = "DataRate",
  DataSize = "DataSize",
  Density = "Density",
  Distance = "Distance",
  ElectricCharge = "ElectricCharge",
  Energy = "Energy",
  Force = "Force",
  Frequency = "Frequency",
  Humidity = "Humidity",
  Illuminance = "Illuminance",
  Inductance = "Inductance",
  Latitude = "Latitude",
  Length = "Length",
  Longitude = "Longitude",
  Luminance = "Luminance",
  Luminosity = "Luminosity",
  LuminousFlux = "LuminousFlux",
  LuminousIntensity = "LuminousIntensity",
  MagneticFlux = "MagneticFlux",
  MagneticInduction = "MagneticInduction",
  Mass = "Mass",
  MassFlowRate = "MassFlowRate",
  Percent = "Percent",
  Power = "Power",
  Pressure = "Pressure",
  ReactivePower = "ReactivePower",
  RelativeHumidity = "RelativeHumidity",
  Resistance = "Resistance",
  SoundPressure = "SoundPressure",
  Temperature = "Temperature",
  Thrust = "Thrust",
  TimeSpan = "TimeSpan",
  Torque = "Torque",
  Velocity = "Velocity",
  Voltage = "Voltage",
  Volume = "Volume",
  VolumeFlowRate = "VolumeFlowRate",
  ReactiveEnergy = "ReactiveEnergy"
}
